var map = {
	"./default.webp": "./src/assets/images/logos/default.webp",
	"./p1.webp": "./src/assets/images/logos/p1.webp",
	"./worldcup-logo.webp": "./src/assets/images/logos/worldcup-logo.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/logos sync recursive ^\\.\\/.*\\.webp$";